/**
 * The admin shell's PRODUCT NAME as a human reads it. `ADMIN_APP_NAME` (`const/auth-session.ts`) is the machine slug
 * `mission-control` and is a different decision; this is the display string, and it was spelled inline at six admin
 * sites -- the root-layout title default and template, the layout description, the G4 guard's `pageName`, the auth
 * modal title, and the error route's default message -- until 2026-08-22.
 *
 * A login page outside this leaf's app adopted it on 2026-08-22, keyed off `appName === ADMIN_APP_NAME` (the auth
 * worker's, deleted with that worker 2026-09-21), which is why the basename names the OWNING app, not the consumer set.
 */
export const TITLE_MISSION_CONTROL = 'Mission Control';

/** Derived, not re-typed: the last-resort error surfaces are "<product> Error", so the product name has one spelling. */
export const TITLE_MISSION_CONTROL_ERROR = `${TITLE_MISSION_CONTROL} Error`;

export const TITLE_BANK_ACCOUNTS = 'Bank Accounts';
